<template>

    <div class="custom-form-section mb-3">
        <div class="row g-3">
            <div class="col-md-5">
                <input-text
                    name="name"
                    label="Namn"
                    v-model="name"
                    formGroupClass="mb-0"
                />
            </div>
            <div class="col-md-4">
                <input-text
                    name="title"
                    label="Titel"
                    v-model="title"
                    formGroupClass="mb-0"
                />
            </div>
            <div class="col-md-6">
                <input-text
                    name="email"
                    label="E-post"
                    v-model="email"
                    formGroupClass="mb-0"
                />
            </div>
            <div class="col-md-3">
                <input-text
                    name="phone_1"
                    label="Telefonnummer 1"
                    v-model="phone_1"
                    formGroupClass="mb-0"
                />
            </div>
            <div class="col-md-3">
                <input-text
                    name="phone_2"
                    label="Telefonnummer 2"
                    v-model="phone_2"
                    formGroupClass="mb-0"
                />
            </div>
            <div class="col-md-3 d-flex justify-content-end">
                <button class="btn btn-danger btn-sm me-2" style="margin-top: 30px;" :disabled="deleter.submitted" @click="triggerDelete()">
                    <img src="/images/admin/icon-trash.svg">
                    <div class="tooltip-label">Ta bort kontaktpersonen.</div>
                </button>
                <button class="btn btn-primary btn-sm" style="margin-top: 30px;" :disabled="patcher.submitted" @click="patcherPatch()">
                    Spara
                </button>
            </div>
        </div>
    </div>

</template>

<script>

import patcher from '../../../../shared/mixins/patcher'
import deleter from '../../../../shared/mixins/deleter'

export default {

    mixins: [
        patcher,
        deleter
    ],

    props: {
        contact: {
            required: true
        }
    },

    data () {
        return {
            name: this.contact.name,
            title: this.contact.title,
            email: this.contact.email,
            phone_1: this.contact.phone_1,
            phone_2: this.contact.phone_2
        }
    },

    computed: {

        patcherUrl () {
            return '/workplaces/' + this.contact.workplace_id + '/contacts/' + this.contact.id
        },

        patcherData () {
            return {
                name: this.name,
                title: this.title,
                email: this.email,
                phone_1: this.phone_1,
                phone_2: this.phone_2
            }
        },

        deleterUrl () {
            return '/workplaces/' + this.contact.workplace_id + '/contacts/' + this.contact.id
        }
    },

    methods: {
        patcherSuccess () {
            bus.$emit(
                'notify',
                'Kontaktpersonen har sparats.'
            )
        },

        triggerDelete () {
            if (!confirm('Vill du verkligen ta bort kontaktpersonen? Detta kan inte ångras.')) {
                return
            }
            this.deleterDelete()
        },

        deleterSuccess () {
            bus.$emit(
                'notify',
                'Kontaktpersonen har tagits bort.'
            )
            this.$emit('refresh')
        }
    }
}
</script>
